import { ImportEmployeesHeader, ImportEmployeesTable } from '@pages/onboarding/containers';
import { saveImportedEmployees } from '@api/onboarding';
import { OnboardingStep } from '@interfaces/models';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, toast } from '@ui/components';
import { Routes } from '@shared/enums';

export const OnboardingImportEmployees = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: () => saveImportedEmployees({ nextStep: OnboardingStep.TOP_UP_BALANCE }),
    onSuccess: () => {
      navigate(`../${Routes.TOP_UP_BALANCE}`);
    },
    onError: () => {
      toast.error(t(`API_ERRORS.DEFAULT`));
    },
  });

  return (
    <div>
      <ImportEmployeesHeader />
      <ImportEmployeesTable />

      <Button onClick={() => mutate()} isLoading={isPending} disabled={isPending} size="large" wide>
        {t('ONBOARDING.IMPORT_EMPLOYEES.SAVE_AND_CONTINUE')}
      </Button>
    </div>
  );
};
